// extracted by mini-css-extract-plugin
module.exports = {"root":"Chat_root__5Qwp5","messages":"Chat_messages__2SmEg","dateDivider":"Chat_dateDivider__1W_L3"};